// @flow
import React from 'react';
import SearchForm from 'app/components/home/SearchForm';
import { Title } from './elements';
import { FormattedMessage } from 'mz-intl';
import messages from '../../messages.intl';

const SearchBlock = () => (
  <SearchForm
    hourlyTitle={
      <Title>
        <FormattedMessage message={messages.SEARCH_HOURLY_TITLE} />
      </Title>
    }
    title={
      <Title>
        <FormattedMessage message={messages.SEARCH_TITLE} />
      </Title>
    }
  />
);

export default SearchBlock;
